module.exports = __webpack_public_path__ + "img/woman.2dbd7977.svg";